import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  type: "button",
  class: "action-menu-item"
}

interface Props {
  /** Icon name to display */
  icon: string
  /** Label text for the menu item */
  label: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseActionMenuButton',
  props: {
    icon: {},
    label: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_VIcon = _resolveComponent("VIcon")!

  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    _createVNode(_component_VIcon, {
      icon: __props.icon,
      size: "1.125rem",
      class: "mr-2 text-secondary-600"
    }, null, 8, ["icon"]),
    _createTextVNode(" " + _toDisplayString(__props.label), 1)
  ]))
}
}

})